"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const EditButton = ({ device }) => {
    switch (device) {
        case 'Desktop':
            return (React.createElement(src_1.Button, { text: "Edit", type: "regular", mouseDownColors: {
                    active: src_1.turquoise,
                    inactive: src_1.aquamarine,
                } }));
        case 'Tablet':
            return React.createElement(src_1.ChangeIcon, { fill: src_1.titanium });
        case 'Mobile':
        default:
            return null;
    }
};
exports.default = EditButton;
